import { apiClient } from "./client";

export const citiesApi = {
  list: (params?: { status?: string; province?: string; search?: string }) =>
    apiClient.get("/geography/cities/", { params }),

  detail: (slug: string) =>
    apiClient.get(`/geography/cities/${slug}/`),

  summary: (slug: string) =>
    apiClient.get(`/cities/${slug}/summary/`),

  decision: (slug: string) =>
    apiClient.get(`/decisions/cities/${slug}/decision/`),

  forecast: (slug: string) =>
    apiClient.get(`/forecasting/cities/${slug}/`),

  market: (slug: string) =>
    apiClient.get(`/market/cities/${slug}/snapshots/`),

  analogs: (slug: string) =>
    apiClient.get(`/market/cities/${slug}/analog-cities/`),

  flows: (slug: string) =>
    apiClient.get(`/mobility/cities/${slug}/flows/`),

  competitors: (slug: string) =>
    apiClient.get(`/competitors/cities/${slug}/observations/`),

  competitorScores: (slug: string) =>
    apiClient.get(`/competitors/cities/${slug}/scores/`),

  financialProjection: (slug: string) =>
    apiClient.get(`/economics/cities/${slug}/projection/`),

  financialAssumptions: (slug: string) =>
    apiClient.get(`/economics/cities/${slug}/assumptions/`),

  supplySimulate: (slug: string) =>
    apiClient.get(`/supply/cities/${slug}/simulate/`),

  scenarios: (slug: string) =>
    apiClient.get(`/scenarios/cities/${slug}/`),

  runScenario: (slug: string, overrides: Record<string, unknown>) =>
    apiClient.post(`/economics/cities/${slug}/scenario/`, overrides),

  generatePilot: (slug: string) =>
    apiClient.post(`/pilots/cities/${slug}/generate/`),

  investmentMemo: (slug: string) =>
    apiClient.get(`/reports/cities/${slug}/memo/`),
};

export const portfolioApi = {
  comparison: () => apiClient.get("/portfolio/comparison/"),
};

export const authApi = {
  login: (email: string, password: string) =>
    apiClient.post("/auth/login/", { email, password }),
  logout: (refresh: string) =>
    apiClient.post("/auth/logout/", { refresh }),
  me: () => apiClient.get("/auth/me/"),
};
